<div class="container mt-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h1>Relatório de Contas a Pagar – Agrupado</h1>
    <span *ngIf="carregado && relatorio" class="badge bg-secondary">
      Total: {{ relatorio.totalRegistros }} conta(s)
    </span>
  </div>
  <hr />

  <!-- Filtros -->
  <div class="row g-2 align-items-end mb-3 no-print">
    <div class="col-md-2">
      <label class="form-label">Período por</label>
      <select class="form-select" [(ngModel)]="tipoData">
        <option value="VENCIMENTO">Vencimento</option>
        <option value="PAGAMENTO">Pagamento</option>
      </select>
    </div>

    <div class="col-md-2">
      <label class="form-label">Data Inicial <span class="text-danger">*</span></label>
      <input type="date" class="form-control campo-obrigatorio" required
             [class.is-invalid]="dataInicialInvalida"
             [(ngModel)]="dataInicial" />
      <div class="invalid-feedback" *ngIf="dataInicialInvalida">
        Informe a data inicial.
      </div>
    </div>

    <div class="col-md-2">
      <label class="form-label">Data Final <span class="text-danger">*</span></label>
      <input type="date" class="form-control campo-obrigatorio" required
             [class.is-invalid]="dataFinalInvalida"
             [(ngModel)]="dataFinal" />
      <div class="invalid-feedback" *ngIf="dataFinalInvalida">
        Informe a data final.
      </div>
    </div>

    <div class="col-md-2">
      <label class="form-label">Status</label>
      <select class="form-select" [(ngModel)]="status">
        <option value="">Todos</option>
        <option value="AGUARDANDO">Aguardando</option>
        <option value="CONCLUIDO">Concluído</option>
      </select>
    </div>

    <div class="col-md-2">
      <label class="form-label">Agrupar por</label>
      <select class="form-select" [(ngModel)]="agrupamento">
        <option value="GRUPO_SUBGRUPO">Grupo e Subgrupo</option>
        <option value="GRUPO">Somente Grupo</option>
      </select>
    </div>

    <div class="col-md-2 d-flex gap-2">
      <button class="btn btn-primary w-100" (click)="buscar()" [disabled]="carregando">
        <span *ngIf="carregando" class="spinner-border spinner-border-sm me-1"></span>
        Buscar
      </button>
      <button class="btn btn-outline-secondary w-100" (click)="limpar()" [disabled]="carregando">
        Limpar
      </button>
    </div>
  </div>

  <div class="alert alert-warning no-print mb-3"
       *ngIf="tentouBuscar && (!dataInicial || !dataFinal)">
    Informe a data inicial e a data final para gerar o relatório.
  </div>

  <div *ngIf="carregando" class="alert alert-info no-print" role="alert">
    Carregando relatório...
  </div>

  <!-- Resultados -->
  <div *ngIf="carregado && relatorio">

    <div class="d-flex justify-content-between align-items-center mb-2 no-print">
      <div class="resumo-periodo">
        <span class="badge-periodo">{{ periodoLabel }}</span>
        <span class="badge-periodo">Status: {{ statusLabel }}</span>
        <span class="badge-periodo">
          {{ agrupaPorSubgrupo ? 'Grupo e Subgrupo' : 'Somente Grupo' }}
        </span>
      </div>
      <button class="btn btn-outline-dark btn-sm" (click)="imprimir()">Imprimir Relatório</button>
    </div>

    <div *ngIf="grupos.length === 0" class="text-center text-muted py-4">
      Nenhuma conta encontrada para os filtros selecionados.
    </div>

    <div class="table-responsive" *ngIf="grupos.length > 0">
      <table class="table table-hover align-middle">
        <thead class="table-dark">
          <tr>
            <th scope="col">Grupo / Subgrupo / Fornecedor</th>
            <th scope="col">Descrição</th>
            <th scope="col" class="text-center">Vencimento</th>
            <th scope="col" class="text-center">Pagamento</th>
            <th scope="col" class="text-center">Status</th>
            <th scope="col" class="text-end">Valor Previsto</th>
            <th scope="col" class="text-end">Valor Pago</th>
            <th scope="col" class="text-end">% do Total</th>
          </tr>
        </thead>

        <tbody *ngFor="let grupo of grupos">
          <!-- Nível 1: grupo -->
          <tr class="linha-grupo" (click)="alternar(chaveGrupo(grupo))">
            <td colspan="5">
              <span class="toggle">{{ estaRecolhido(chaveGrupo(grupo)) ? '▸' : '▾' }}</span>
              {{ grupo.grupo }}
              <span class="contagem">({{ grupo.totalRegistros }} conta(s))</span>
            </td>
            <td class="text-end">{{ grupo.valorTotalPrevisto | currency:'BRL' }}</td>
            <td class="text-end">{{ grupo.valorTotalPago | currency:'BRL' }}</td>
            <td class="text-end">{{ percentual(grupo.valorTotalPrevisto) | number:'1.1-1' }}%</td>
          </tr>

          <ng-container *ngIf="!estaRecolhido(chaveGrupo(grupo))">

            <!-- Agrupamento por grupo e subgrupo -->
            <ng-container *ngIf="agrupaPorSubgrupo">
              <ng-container *ngFor="let sub of grupo.subgrupos">
                <tr class="linha-subgrupo"
                    (click)="alternar(chaveSubgrupo(grupo, sub.subgrupoId, sub.subgrupo))">
                  <td colspan="5" class="ps-4">
                    <span class="toggle">
                      {{ estaRecolhido(chaveSubgrupo(grupo, sub.subgrupoId, sub.subgrupo)) ? '▸' : '▾' }}
                    </span>
                    {{ sub.subgrupo }}
                    <span class="contagem">({{ sub.totalRegistros }} conta(s))</span>
                  </td>
                  <td class="text-end">{{ sub.valorTotalPrevisto | currency:'BRL' }}</td>
                  <td class="text-end">{{ sub.valorTotalPago | currency:'BRL' }}</td>
                  <td class="text-end">{{ percentual(sub.valorTotalPrevisto) | number:'1.1-1' }}%</td>
                </tr>

                <ng-container *ngIf="!estaRecolhido(chaveSubgrupo(grupo, sub.subgrupoId, sub.subgrupo))">
                <tr class="linha-item" *ngFor="let item of sub.itens">
                  <td class="ps-5">{{ item.fornecedor }}</td>
                  <td>{{ item.descricao }}</td>
                  <td class="text-center">{{ formatDate(item.dataVencimento) }}</td>
                  <td class="text-center">{{ formatDate(item.dataPagamento) }}</td>
                  <td class="text-center">
                    <span class="badge"
                          [class.bg-success]="item.status === 'CONCLUIDO'"
                          [class.bg-warning]="item.status === 'AGUARDANDO'"
                          [class.text-dark]="item.status === 'AGUARDANDO'">
                      {{ item.status }}
                    </span>
                  </td>
                  <td class="text-end">{{ item.valorPrevisto | currency:'BRL' }}</td>
                  <td class="text-end">{{ item.valorPago | currency:'BRL' }}</td>
                  <td></td>
                </tr>
                </ng-container>
              </ng-container>
            </ng-container>

            <!-- Agrupamento somente por grupo -->
            <ng-container *ngIf="!agrupaPorSubgrupo">
              <tr class="linha-item" *ngFor="let item of grupo.itens">
                <td class="ps-4">{{ item.fornecedor }}</td>
                <td>{{ item.descricao }}</td>
                <td class="text-center">{{ formatDate(item.dataVencimento) }}</td>
                <td class="text-center">{{ formatDate(item.dataPagamento) }}</td>
                <td class="text-center">
                  <span class="badge"
                        [class.bg-success]="item.status === 'CONCLUIDO'"
                        [class.bg-warning]="item.status === 'AGUARDANDO'"
                        [class.text-dark]="item.status === 'AGUARDANDO'">
                    {{ item.status }}
                  </span>
                </td>
                <td class="text-end">{{ item.valorPrevisto | currency:'BRL' }}</td>
                <td class="text-end">{{ item.valorPago | currency:'BRL' }}</td>
                <td></td>
              </tr>
            </ng-container>

          </ng-container>
        </tbody>

        <tfoot>
          <tr class="linha-total">
            <td colspan="5" class="text-end fw-bold">Total geral:</td>
            <td class="text-end fw-bold">{{ relatorio.valorTotalPrevisto | currency:'BRL' }}</td>
            <td class="text-end fw-bold">{{ relatorio.valorTotalPago | currency:'BRL' }}</td>
            <td class="text-end fw-bold">100,0%</td>
          </tr>
        </tfoot>
      </table>
    </div>

  </div>
</div>
